import Exits from '@/components/Investment/Exit'
import CreateExit from '@/components/Investment/CreateExit'
import Enum from '@/shared/enum'

let ExitsRoutes = [
  {
    meta: {
      title: 'menu.exits',
      ico: 'sign-out',
      permission: ['Pages.Exits'],
    },
    path: '/projects/Exits',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'exits',
        path: '',
        meta: {permission: ['Pages.Exits.View']},
        component: Exits,
      },
      {
        name: 'exits_edit',
        path: 'edit/:id',
        props: {compMode: Enum.Mode.UPDATE},
        meta: {permission: ['Pages.Exits.Create']},
        component: CreateExit,
      },
      {
        name: 'exits_view',
        path: 'view/:id',
        props: {compMode: Enum.Mode.READ},
        meta: {permission: ['Pages.Exits.View']},
        component: CreateExit,
      },
      {
        name: 'exits_copy',
        path: 'copy/:id',
        props: {compMode: Enum.Mode.COPY},
        meta: {permission: ['Pages.Exits.Create']},
        component: CreateExit,
      },
      {
        name: 'exits_projects',
        path: '/projects/:project_id/Exits',
        meta: {permission: ['Pages.Exits.View']},
        component: Exits,
      },
      {
        name: 'exits_create',
        path: '/projects/:project_id?/Exits/create',
        meta: {permission: ['Pages.Exits.Create']},
        props: {compMode: Enum.Mode.CREATE},
        component: CreateExit,
      },
    ],
  },
]

export default ExitsRoutes



// WEBPACK FOOTER //
// ./src/router/exits.js